import { TextV2 } from '@insights-ltd/design-library/components';
import { Link as RouterLink } from 'react-router';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import type { OrganisationResponse } from 'api';

interface OrganisationColumnProps {
  organisations?: OrganisationResponse[];
}

const OrganisationColumn = ({ organisations }: OrganisationColumnProps) => {
  const { t } = useTranslation();
  const organisationCount = organisations?.length ?? 1;
  const organisationCountText = t(
    'ui.event-management.users.invite.organisations-plural',
    { count: organisationCount },
  );
  return organisationCount > 1 ? (
    <TextV2>{organisationCountText}</TextV2>
  ) : (
    <Link
      component={RouterLink}
      to={`/organisations/${organisations?.[0].id ?? ''}`}
    >
      <TextV2 variant="bodyBold" color="primary">
        {organisations?.[0]?.name ?? ''}
      </TextV2>
    </Link>
  );
};
export default OrganisationColumn;
